var FourDotFivePhoneNumberController = /** @class */ (function () {
    /*@ngInject*/
    function FourDotFivePhoneNumberController($timeout) {
        this.$timeout = $timeout;
    }
    FourDotFivePhoneNumberController.prototype.$onInit = function () {
        var _this = this;
        this.phoneNumberFormat = '+1 201-555-0123';
        if (_.isUndefined(this.elementId)) {
            this.elementId = "candidateContactPhoneNumber";
        }
        if (_.isUndefined(this.classes)) {
            this.classes = "";
        }
        if (_.isUndefined(this.defaultCountry)) {
            this.defaultCountry = "us";
        }
        if (_.isUndefined(this.disabledValue)) {
            this.disabledValue = false;
        }
        if (_.isUndefined(this.requiredValue)) {
            this.requiredValue = true;
        }
        this.$timeout(function () {
            if (!_.isNull(_this.valueField) && !_.isUndefined(_this.valueField)) {
                $('#' + _this.elementId).intlTelInput("setNumber", _this.valueField);
            }
            if (_.isNull(document.getElementById(_this.elementId))) {
                _this.phoneNumberFormat = "";
            }
            else {
                _this.phoneNumberFormat = document.getElementById(_this.elementId).placeholder;
            }
            // set up the handler for country change
            $('#' + _this.elementId).on('countrychange', function (e, countryData) {
                _this.$timeout(function () {
                    if (!_.isNull(_this.valueField)) {
                        _this.valueField = $('#' + _this.elementId).intlTelInput("getNumber");
                        $('#' + _this.elementId).intlTelInput("setNumber", _this.valueField);
                    }
                    _this.phoneNumberFormat = document.getElementById(_this.elementId).placeholder;
                }, 100);
            });
        }, 300);
    };
    FourDotFivePhoneNumberController.prototype.phoneNumberChanged = function () {
        var _this = this;
        this.$timeout(function () {
            _this.valueField = $('#' + _this.elementId).intlTelInput("getNumber");
            $('#' + _this.elementId).intlTelInput("setNumber", _this.valueField);
        }, 100);
    };
    return FourDotFivePhoneNumberController;
}());
FourDotFivePhoneNumberController.$inject = ['$timeout'];
// import * as TEMPLATE from './four-dot-five-phone-number.html';
import * as TEMPLATE from 'raw-loader!./four-dot-five-phone-number.html';
export var FourDotFivePhoneNumberComponent = {
    selector: 'fourDotFivePhoneNumber',
    component: {
        bindings: {
            elementId: '@',
            classes: '@',
            defaultCountry: '@',
            valueField: '=',
            requiredValue: '=',
            disabledValue: '='
        },
        controller: FourDotFivePhoneNumberController,
        // templateUrl: 'app/shared/fourDotFivePhoneNumber/four-dot-five-phone-number.html'
        template: TEMPLATE.default
    }
};
//# sourceMappingURL=four-dot-five-phone-number.component.js.map